import globalToast from "../components/common/globalToast";
import api from "../services/api";

const service_path = "/settings.php";

export function getAppSettings() {
    return api.get(service_path);
}

export function updateAppSettings(data, navigateBack) {
    api.patch(service_path, data)
        .then((response) => {
            const { data: body } = response;
            if (body.success) {
                globalToast.success("Configurações salvas.");
                navigateBack?.();
            } else {
                globalToast.error(body.message);
            }
        })
        .catch((error) => {
            console.log(error);
            globalToast.error("Houve um erro ao salvar as configurações.");
        });
}
